import { generateTagBorderCommand } from "./generateTagBorderCommand";

export default generateTagBorderCommand;
